/**
 * Created by jonas on 2021-12-13.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {TrueGrit} from "../TrueGrit";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {LoopableList} from "../utils/LoopableList";

export class TrueGritMuzzleFlashView extends PIXI.Container implements StageLayer {
    private _redTimeline:gsap.core.Timeline;
    private _leftRed:PIXI.Sprite;
    private _rightRed:PIXI.Sprite;
    private _redSpotsPool:PIXI.Sprite[] = [];
    private _yellowShotPool:TimelineSprite[] = [];

    private _yellowShotPositions:LoopableList<{position:PIXI.Point, rotation:number}> = new LoopableList([
        //Right
        {position:new PIXI.Point(500 + 360, -255 + 360), rotation:-0.63},
        {position:new PIXI.Point(520 + 360, -90 + 360), rotation:-0.24},
        {position:new PIXI.Point(553 + 360, 40 + 360), rotation:0.06},
        {position:new PIXI.Point(540 + 360, 190 + 360), rotation:0.27},
        {position:new PIXI.Point(448 + 360, 210 + 360), rotation:0.47},

        //Left
        {position:new PIXI.Point(-500 + 360, -255 + 360), rotation:0.63 + Math.PI},
        {position:new PIXI.Point(-520 + 360, -90 + 360), rotation:0.24 + Math.PI},
        {position:new PIXI.Point(-553 + 360, 40 + 360), rotation:-0.06 + Math.PI},
        {position:new PIXI.Point(-540 + 360, 200 + 360), rotation:-0.27 + Math.PI},
        {position:new PIXI.Point(-448 + 360, 280 + 360), rotation:-0.47 + Math.PI}
    ]).setRandomizeAtWrapAround(true);

    constructor() {
        super();
        this.name = "TrueGritMuzzleFlashView";
        this.init();
    }


    onResize() {
      // this.position.set(0,NolimitApplication.screenBounds.top);
        this._leftRed.position.set(NolimitApplication.screenBounds.left-70, 360);
        this._rightRed.position.set(NolimitApplication.screenBounds.right+70, 360);


    }

    private init() {
        this._leftRed = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("backgroundEffect/bloodB_02")[0]);
        this._leftRed.blendMode = PIXI.BLEND_MODES.ADD;
        this._leftRed.anchor.set(1, 0.5);
        this._leftRed.scale.x = -1;
        this._leftRed.alpha = 0;
        this._leftRed.name = "_leftRed";
        this.addChild(this._leftRed);

        this._rightRed = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("backgroundEffect/bloodB_02")[0]);
        this._rightRed.blendMode = PIXI.BLEND_MODES.ADD;
        this._rightRed.anchor.set(1, 0.5);
        this._rightRed.alpha = 0;
        this._rightRed.name = "_rightRed";
        this.addChild(this._rightRed);
    }


    public playScreenAnimation(delay:number):void {
/*        if (this._redTimeline && this._redTimeline.isActive()) {
            this._redTimeline.pause();
            this._redTimeline.kill();
        }*/

        const tl = gsap.timeline({delay:delay});
        tl.add(() => this.onResize());
        tl.add([
            gsap.to(this._leftRed, {duration:0.067, alpha:0.43}),
            gsap.to(this._rightRed, {duration:0.067, alpha:0.43})
        ]);
        tl.add([
            gsap.to(this._leftRed, {duration:0.533, alpha:0}),
            gsap.to(this._rightRed, {duration:0.533, alpha:0})
        ]);
        //this._redTimeline = tl;


        let yellow:TimelineSprite;
        if (this._yellowShotPool.length > 0) {
            yellow = this._yellowShotPool.pop()!
        } else {
            yellow = new TimelineSprite(TrueGrit.assetLoader.getTextures("backgroundEffect/gunFire/fire_"));
            yellow.anchor.set(0.5);
            yellow.scale.set(1.5);
            yellow.alpha = 0.6;
            yellow.blendMode = PIXI.BLEND_MODES.ADD;
        }
        const yellowConfig = this._yellowShotPositions.next();
        yellow.position.set(yellowConfig.position.x, yellowConfig.position.y);
        yellow.rotation = yellowConfig.rotation;
        this.addChild(yellow);
        tl.add(yellow.getAnimationAutoShowHide(true, true, undefined, undefined, () => {
            this.removeChild(yellow);
            this._yellowShotPool.push(yellow);
        }), 0);

    /*    // randomly play redSpot
        if (Math.random() > 0.5) {
            return;
        }

        let red:PIXI.Sprite;
        if (this._redSpotsPool.length > 0) {
            red = this._redSpotsPool.pop()!;
        } else {
            red = new PIXI.Sprite(TrueGrit.assetLoader.getTextures("backgroundEffect/bloodA")[0]);
            red.anchor.set(0.5);
            red.blendMode = PIXI.BLEND_MODES.ADD;
        }
        red.alpha = 0;
        red.scale.set(Math.random() * 0.15 + 0.65);
        red.position.set(Math.random() * 720, Math.random() * 720);
        const randomAlpha = Math.random() * 0.2 + 0.6;
        this.addChild(red);
        const redDotTl:gsap.core.Timeline = gsap.timeline();
        redDotTl.to(red, {duration:0.067, alpha:randomAlpha})
            .to(red, {
                duration:0.333,
                alpha:0, onComplete:() => {
                    this.removeChild(red);
                    this._redSpotsPool.push(red);
                }
            });
        tl.add(redDotTl);*/
    }

}